// StatusCell.js
import React from "react";
import { useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import { updateModifiedRow } from "../../redux/validation/validationResultsSlice"

// Define the order of statuses that we want to cycle through.
const statuses = ["Pass", "Fail", "Missing", "Extra"];

const StatusCell = (props) => {
  const { value, row } = props; // value comes from the DataGrid cell, row contains the entire row data
  const dispatch = useDispatch();
  const readOnly = row.readOnly || false; // Get readOnly flag from row data

  const toggleStatus = () => {
    // Don't allow toggling in read-only mode
    if (readOnly) return;

    const currentIndex = statuses.indexOf(value);
    const newStatus = statuses[(currentIndex + 1) % statuses.length];
    // Dispatch the action to update the modifiedRows for this beacon instance.
    // Here we assume the row carries a unique identifier (for example, row.index or row.id) and variableName.
    dispatch(
      updateModifiedRow({
        beaconIndex: row.index,
        variableName: row.variableName,
        newStatus,
      })
    );
  };

  return (
    <Box
      sx={{ position: "relative", cursor: readOnly ? "default" : "pointer", height: "100%" }}
      onClick={toggleStatus}
    >
      {value === "Pass" && (
        <img
          src="/pass.png"
          alt="Pass"
          style={{ width: "30px", height: "30px" }}
        />
      )}
      {value === "Fail" && (
        <img
          src="/fail.png"
          alt="Fail"
          style={{ width: "30px", height: "30px" }}
        />
      )}
      {value === "Missing" && (
        <img
          src="/miss.png"
          alt="Missing"
          style={{ width: "30px", height: "30px" }}
        />
      )}
      {value === "Extra" && (
        <img
          src="/extra.png"
          alt="Extra"
          style={{ width: "30px", height: "30px" }}
        />
      )}
      {row.modified && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            backgroundColor: "rgba(255,255,255,0.8)",
            borderRadius: "50%",
            width: "16px",
            height: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.7rem",
          }}
        >
          *
        </Box>
      )}
    </Box>
  );
};

export default StatusCell;
